import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import RemitterPersonalDetail from "./remitterPersonalDetail";
import RemitterBankDetail from "./remitterBankDetail";
import KycUpload from "./kycUpload";
import { fetchDetails } from "../../../api";
import { useMyContext } from "../../../myContext";
import DocumentTypeUpload from "./documentTypeUplaod";

const Remitter = ({ stepToShow, setStepsToShow }) => {
  const [filteredList, setFilteredList] = useState([]);
  const [kycLoader, setKycLoader] = useState(false);
  const [reqDocs, setReqDocs] = useState([]);
  const {
    setRemitterSecondFlow,
    showkyc,
    remitterUserId,
    completedRemitter,
    completedStudent,
    completedBeneficiary,
    remitterShortDetail,
    setRemitterShortDetail,
    shortRemitterBankDetail,
    setShortRemitterBankDetail,
    showRemitterDetail,
    setShowRemitterDetail,
    showRemitterBankDetail,
    setShowRemitterBankDetail,
    remitterCardSelection,
    setRemitterCardSelection,
    uploadError,
    setUploadError,
  } = useMyContext();

  const [remitterLoader, setRemitterLoader] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [addnewButton, setAddnewButton] = useState(false);

  const fetchRemitterData = async () => {
    try {
      fetchDetails("Remitter").then((response) => {
        setRemitterLoader(false);
        if (remitterUserId) {
          const selectedCard = response.data.find(
            (item) => item.userAccountId === remitterUserId,
          );
          if (selectedCard) {
            const temporaryList = response.data.filter(
              (item) => item.userAccountId !== remitterUserId,
            );
            temporaryList.push(selectedCard);
            setFilteredList(temporaryList);
          }
        } else {
          setFilteredList(response.data);
        }
        if (!showRemitterDetail) {
          if (response && response.data && response.data.length !== 0) {
            setRemitterCardSelection(true);
            setRemitterSecondFlow(true);
            setAddnewButton(false);
          } else {
            setRemitterSecondFlow(false);
            setRemitterCardSelection(false);
            setAddnewButton(true);
          }
        }
      });
    } catch (error) {
      setRemitterLoader(false);
    }
  };

  useEffect(() => {
    if (!showRemitterDetail) setRemitterLoader(true);
    fetchRemitterData();
  }, []);

  const fetchCardDetail = () => {
    setRemitterCardSelection(true);
    setShowRemitterDetail(false);
    setRemitterLoader(true);
    fetchRemitterData();
  };

  useEffect(() => {
    if (
      !completedRemitter &&
      completedStudent &&
      completedBeneficiary &&
      !showRemitterDetail
    ) {
      setRemitterLoader(true);
      fetchRemitterData();
    }
  }, [completedStudent, completedBeneficiary]);

  return (
    <div className={styles.cardDetails}>
      <>
        <h1 className={styles.onboardHeading}>1. Remitter</h1>
        {filteredList?.length === 0 ? (
          <>
            <RemitterPersonalDetail
              stepToShow={stepToShow}
              setReqDocs={setReqDocs}
              setStepsToShow={setStepsToShow}
              shortDetail={remitterShortDetail}
              setShortDetail={setRemitterShortDetail}
              remitterLoader={remitterLoader}
              setRemitterLoader={setRemitterLoader}
              setShowRemitterBankDetail={setShowRemitterBankDetail}
              showRemitterDetail={showRemitterDetail}
              setShowRemitterDetail={setShowRemitterDetail}
              setKycLoader={setKycLoader}
              setErrorStatus={setErrorStatus}
              remitterCardSelection={remitterCardSelection}
              setRemitterCardSelection={setRemitterCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
            />
            {/* todo check this kyc section */}

            {showkyc === true && (
              <DocumentTypeUpload
                reqDocs={reqDocs}
                stepToShow={stepToShow}
                setStepsToShow={setStepsToShow}
              />
            )}
            {/* <KycUpload
                stepToShow={stepToShow}
                setStepsToShow={setStepsToShow}
                kycLoader={kycLoader}
                setKycLoader={setKycLoader}
                errorStatus={errorStatus}
                setErrorStatus={setErrorStatus}
              /> */}

            <RemitterBankDetail
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortBankDetail={shortRemitterBankDetail}
              setShortBankDetail={setShortRemitterBankDetail}
              showRemitterBankDetail={showRemitterBankDetail}
              setShowRemitterBankDetail={setShowRemitterBankDetail}
            />
          </>
        ) : (
          <>
            <RemitterPersonalDetail
              stepToShow={stepToShow}
              setReqDocs={setReqDocs}
              setStepsToShow={setStepsToShow}
              remitterList={filteredList}
              shortDetail={remitterShortDetail}
              setShortDetail={setRemitterShortDetail}
              remitterLoader={remitterLoader}
              setRemitterLoader={setRemitterLoader}
              setShowRemitterBankDetail={setShowRemitterBankDetail}
              showRemitterDetail={showRemitterDetail}
              setShowRemitterDetail={setShowRemitterDetail}
              setKycLoader={setKycLoader}
              setErrorStatus={setErrorStatus}
              remitterCardSelection={remitterCardSelection}
              setRemitterCardSelection={setRemitterCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
            />

            {/* todo check this kyc section */}
            {showkyc === true ? (
              <>
                {/* <KycUpload
                  stepToShow={stepToShow}
                  setStepsToShow={setStepsToShow}
                  kycLoader={kycLoader}
                  setKycLoader={setKycLoader}
                  errorStatus={errorStatus}
                  setErrorStatus={setErrorStatus}
                /> */}
                <DocumentTypeUpload
                  reqDocs={reqDocs}
                  stepToShow={stepToShow}
                  setStepsToShow={setStepsToShow}
                />

                <RemitterBankDetail
                  stepToShow={stepToShow}
                  setStepsToShow={setStepsToShow}
                  shortBankDetail={shortRemitterBankDetail}
                  setShortBankDetail={setShortRemitterBankDetail}
                  showRemitterBankDetail={showRemitterBankDetail}
                  setShowRemitterBankDetail={setShowRemitterBankDetail}
                />
              </>
            ) : (
              <>
                <RemitterBankDetail
                  stepToShow={stepToShow}
                  setStepsToShow={setStepsToShow}
                  shortBankDetail={shortRemitterBankDetail}
                  setShortBankDetail={setShortRemitterBankDetail}
                  showRemitterBankDetail={showRemitterBankDetail}
                  setShowRemitterBankDetail={setShowRemitterBankDetail}
                />
              </>
            )}
          </>
        )}
      </>
    </div>
  );
};
export default Remitter;
